import { render } from "./BlogPost.vue?vue&type=template&id=2096a952&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"

import "./BlogPost.vue?vue&type=style&index=0&id=2096a952&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2096a952"]])

export default __exports__